<template>
  <div class="wrapBox" style=" padding-left:8px;padding-right:4px;padding-top:8px;">
    <div id="myAmountIn" :style="{width: '100%', height: '800px'}"></div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      titleText: "进口贸易量分析",
      textStyle: {
        color: "#ccc",
        fontStyle: "normal",
        fontWeight: "bold",
        fontFamily: "sans-serif",
        fontSize: 12
      },
      legendPadding: [65, 5, 15, 5],
      // data1: [],
      data2: [],
      yearList: []
    };
  },
  computed: {
    myYear() {
      return this.$store.state.myYear;
    },
    myCountry() {
      return this.$store.state.myCountry;
    }
  },
  watch: {
    myYear(curval, oldval) {
      this.listA();
    },
    myCountry(curval, oldval) {
      this.listA();
    }
  },
  mounted() {
    //this.drawLine();
    this.listA();
  },
  methods: {
    listA() {
      this.titleText =
        "进口贸易量分析" + "-" + this.myYear + "-" + this.myCountry;

      this.$ajax({
        method: "get",
        url: "/cee/rest/web/countryAnay",
        params: {
          year: "",
          country: this.myCountry,
          ieflag: "1",
          limit: "20"
        }
      })
        .then(resp => {
          // var res1 = [];
          var res2 = [];
          var yearList = [];

          for (let index = 0; index < resp.data.length; index++) {
            let element = resp.data[index];
            // res1.push(element.qty / 100000000.0);
            res2.push((element.price / 100000000.0).toFixed(2));
            if(index == resp.data.length-1) {
              yearList.push("截至"+element.name);
            } else {
              yearList.push(element.name);
            }
          }
          // this.data1 = res1;
          this.data2 = res2;
          this.yearList = yearList;
          this.drawLine();
        })
        .catch(err => {});
    },
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myAmountIn = this.$echarts.init(
        document.getElementById("myAmountIn"),
        "dark"
      );
      myAmountIn.setOption({
        title: {
          text: "进口贸易量分析",
          left: "left",
          textStyle: this.textStyle
        },

        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999"
            }
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '4%',
          containLabel: true
        },
        legend: {
          data: ["贸易额"],
          padding: [25, 10, 15, 20]
        },
        xAxis: [
          {
            type: "category",
            data: this.yearList,
            axisPointer: {
              type: "shadow"
            },
            axisLabel: {
              show: true,
              interval: "0",
              rotate: 60
            }
          }
        ],
        yAxis: 
        // {
        //   type: "value",
        //   name: "件数（亿）",
        //   min: 0,
        //   max: 80,
        //   interval: 8,
        //   axisLabel: {
        //     formatter: "{value}"
        //   }
        // },
        {
          type: "value",
          name: "贸易额（亿元）",
          min: 0,
          // max: 1500,
          interval: 150,
          axisLabel: {
            formatter: "{value}"
          }
        },
        series: [
          // {
          //   name: "件数",
          //   type: "line",
          //   yAxisIndex: 0,
          //   data: this.data1
          // },
          {
            name: "贸易额",
            type: "line",
            // yAxisIndex: 1,
            data: this.data2
          }
        ]
      });
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AmountIn.vue